import { Box, Typography } from '@mui/material'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { SelectTokenItemProps } from './types'

const SelectTokenItem = ({ token }: SelectTokenItemProps) => {
  if (!token) return null

  return (
    <Box
      key={token.symbol}
      display="flex"
      alignItems="center"
      gap="8px"
      className="pl-2 py-2 pr-1"
    >
      <LazyLoadImage src={token.logoURI} alt={token.displaySymbol} width="24px" height="24px" />
      <Typography className="text-sm font-bold">{token.displaySymbol}</Typography>
    </Box>
  )
}

export default SelectTokenItem
